/**
 * text align
 * Created by peak on 16/8/18.
 */
import dashboard from "./dashboard.vue";
export default {
    name: "align",
    icon: "custom-icon align",
    i18n: "align",
    show: true,
    dashboard
}




// WEBPACK FOOTER //
// ./src/components/editor/src/modules/align/index.js